import React, { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { GrainOverlay } from "@/components/GrainOverlay";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { BrandMarquee } from "@/components/BrandMarquee";
import { Highlights } from "@/components/Highlights";
import { About } from "@/components/About";
import { Experience } from "@/components/Experience";
import { Reviews } from "@/components/Reviews";
import { Location } from "@/components/Location";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { MobileCTABar } from "@/components/MobileCTABar";

function App() {
  useEffect(() => {
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (prefersReduced) return;

    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -70 });
        }
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#050505] text-white antialiased selection:bg-neon selection:text-black">
      <GrainOverlay />
      <Navbar />
      <main>
        <Hero />
        <BrandMarquee />
        <Highlights />
        <About />
        <Experience />
        <Reviews />
        <Location />
        <FinalCTA />
      </main>
      <Footer />
      <MobileCTABar />
      <div className="lg:hidden h-16" aria-hidden />
    </div>
  );
}

export default App;
